import { ContainerModule } from 'inversify';
import { SocketProcessingAdapter } from '@dealroadshow/file-uploader';
import { type ISocketClient } from '@drs/socket-client';
import DrsSocketDITypes from '@drs/socket-client/DITypes';
import DrsUploadDITypes from './types';
import type {
  ISocketProcessingAdapter,
  IUploadDispatcherFactory,
  IUploadAdapter,
  IUploadDispatcher,
} from './interfaces';
import UploadAdapter from '../UploadAdapter';
import UploadDispatcherFactory from '../UploadDispatcherFactory';

export const FileUploadModule = new ContainerModule(({ bind }) => {
  bind<ISocketProcessingAdapter>(DrsUploadDITypes.SocketProcessingAdapter)
    .toDynamicValue(({ get }) => {
      const socketClient = get<ISocketClient>(DrsSocketDITypes.SocketClient);
      return new SocketProcessingAdapter(socketClient);
    })
    .inSingletonScope();

  bind<IUploadAdapter>(DrsUploadDITypes.UploadAdapter).to(UploadAdapter).inSingletonScope();

  bind<IUploadDispatcherFactory>(DrsUploadDITypes.UploadDispatcherFactory)
    .to(UploadDispatcherFactory).inSingletonScope();

  bind<IUploadDispatcher>(DrsUploadDITypes.UploadDispatcher)
    .toDynamicValue(({ get }) => {
      return get<IUploadDispatcherFactory>(DrsUploadDITypes.UploadDispatcherFactory).create();
    })
    .inSingletonScope();
});
